import type { ISerialize } from '@/objects/ISerialize';

export class CreateHeatPlanResponse implements ISerialize {
    public HeatPlanIDs: number[];

    public RaceIDs: number[];

    /***
     * @deprecated Use the static FromJsValues method instead of the constructor to get type safety and default values
     */
    public constructor(values: { HeatPlanIDs?: number[]; RaceIDs?: number[] }) {
        this.HeatPlanIDs = values.HeatPlanIDs ?? [];

        this.RaceIDs = values.RaceIDs ?? [];
    }

    public serialize(): string {
        return (
            '{' +
            `"HeatPlanIDs": [ ${this.HeatPlanIDs.map((x) => JSON.stringify(x))} ]` +
            ',' +
            `"RaceIDs": [ ${this.RaceIDs.map((x) => JSON.stringify(x))} ]` +
            '}'
        );
    }

    /**
     * Creates an instance of CreateHeatPlanResponse from the supplied values.
     * Missing values have default values
     * @param values The values you want to set
     * @returns An object instance with the supplied values set
     */
    public static FromJsValues(values: { HeatPlanIDs?: number[]; RaceIDs?: number[] }): CreateHeatPlanResponse {
        return new CreateHeatPlanResponse(values);
    }

    public static _FromServerJson(json: any): CreateHeatPlanResponse {
        return new CreateHeatPlanResponse({ HeatPlanIDs: json.HeatPlanIDs, RaceIDs: json.RaceIDs });
    }

    /**
     * Creates an instance of CreateHeatPlanResponse from another instance of CreateHeatPlanResponse.
     * @param other The CreateHeatPlanResponse you want to clone
     * @returns A cloned CreateHeatPlanResponse
     */
    public static FromOther(other: CreateHeatPlanResponse): CreateHeatPlanResponse {
        return CreateHeatPlanResponse._FromServerJson(JSON.parse(other.serialize()));
    }

    /**
     * Deepclones the object.
     */
    public DeepClone() {
        return CreateHeatPlanResponse.FromOther(this);
    }

    static NAME_OF_CLASS = 'CreateHeatPlanResponse';
}
